module.exports = __webpack_public_path__ + "img/tingting.b6fb710e.jpg";